type GenericObject = { [key: string]: any };

export function maxBy<T extends GenericObject>(array: T[], key: keyof T): T {
    return array.reduce((max, obj) => (obj[key] > max[key] ? obj : max), array[0]);
}
